import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddGiftProduct = () => {
  const [formData, setFormData] = useState({
    name: '',
    selling_price: '',
    original_price: '',
    shipping_charge: '',
    description: '',
    benefit_description: '',
    giftbox_type: '',
    box_material: '',
    box_size: '',
    box_weight: '',
    stock_quantity: '',
    rating: '',
    status: 'active',

  });
  const [firstImage, setFirstImage] = useState(null);
  const [moreImages, setMoreImages] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = new FormData();
    for (const key in formData) {
      payload.append(key, formData[key]);
    }
    if (firstImage) {
      payload.append('images', firstImage);
    }
    for (let i = 0; i < moreImages.length; i++) {
      payload.append('images', moreImages[i]);
    }

    try {
      await postRequest('gift-products', payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Gift product added successfully!', { position: 'top-right', autoClose: 2000 });
      setTimeout(() => navigate('/gift-products'), 2000);
    } catch (err) {
      console.error('Failed to add gift product:', err);
      toast.error(err?.response?.data?.message || err?.message || 'Something went wrong.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Gift Product</h4>
      </div>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-4 mt-5">
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="name">Name</label>
            <input id="name" type="text" name="name" placeholder="Enter name" className="form-control" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="selling_price">Selling Price</label>
            <input id="selling_price" type="number" step="0.01" name="selling_price" placeholder="Enter selling price" className="form-control" value={formData.selling_price} onChange={handleChange} required />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="original_price">Original Price</label>
            <input id="original_price" type="number" step="0.01" name="original_price" placeholder="Enter original price" className="form-control" value={formData.original_price} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="shipping_charge">Shipping Charge</label>
            <input id="shipping_charge" type="number" step="0.01" name="shipping_charge" placeholder="Enter shipping charge" className="form-control" value={formData.shipping_charge} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="stock_quantity">Stock Quantity</label>
            <input id="stock_quantity" type="number" step="1" name="stock_quantity" placeholder="Enter stock quantity" className="form-control" value={formData.stock_quantity} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="giftbox_type">Giftbox Type</label>
            <input id="giftbox_type" type="text" name="giftbox_type" placeholder="e.g. Premium, Standard" className="form-control" value={formData.giftbox_type} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_material">Box Material</label>
            <input id="box_material" type="text" name="box_material" placeholder="e.g. Wood, Cardboard" className="form-control" value={formData.box_material} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_size">Box Size</label>
            <input id="box_size" type="text" name="box_size" placeholder="e.g. 12x8x4" className="form-control" value={formData.box_size} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="box_weight">Box Weight</label>
            <input id="box_weight" type="number" step="0.01" name="box_weight" placeholder="Enter box weight" className="form-control" value={formData.box_weight} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="rating">Rating</label>
            <input id="rating" type="number" step="0.1" min="0" max="5" name="rating" placeholder="Enter rating" className="form-control" value={formData.rating} onChange={handleChange} />
          </div>
          <div className="col-sm-4 mt-2">
            <label className="admin-label" htmlFor="status">Status</label>
            <select id="status" name="status" className="form-control" value={formData.status} onChange={handleChange}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="col-sm-12 mt-4">
            <label className="admin-label" htmlFor="description">Description</label>
            <textarea id="description" rows={4} name="description" className="form-control" placeholder="Enter description" value={formData.description} onChange={handleChange}></textarea>
          </div>
          <div className="col-sm-12 mt-4">
            <label className="admin-label" htmlFor="benefit_description">Benefit Description</label>
            <textarea id="benefit_description" rows={3} name="benefit_description" className="form-control" placeholder="Enter benefit description" value={formData.benefit_description} onChange={handleChange}></textarea>
          </div>
          <div className="col-sm-6 mt-4">
            <label className="admin-label" htmlFor="giftFirstImage">Choose First Image</label>
            <input id="giftFirstImage" type="file" accept="image/*" className="form-control" onChange={(e) => setFirstImage(e.target.files[0] || null)} />
            {firstImage && (
              <div className="mt-2">
                <img src={URL.createObjectURL(firstImage)} alt="First" width={100} height={100} className="border" style={{ objectFit: 'cover', borderRadius: 4 }} />
                <span className="ml-2 text-success font-weight-bold">First Image</span>
              </div>
            )}
          </div>
          <div className="col-sm-6 mt-4">
            <label className="admin-label" htmlFor="giftMoreImages">Choose More Images</label>
            <input id="giftMoreImages" type="file" accept="image/*" multiple className="form-control" onChange={(e) => setMoreImages(Array.from(e.target.files || []))} />
            {moreImages.length > 0 && (
              <div className="mt-2 d-flex flex-wrap">
                {moreImages.map((file, i) => (
                  <img key={i} src={URL.createObjectURL(file)} alt={`Preview ${i}`} width={80} height={80} className="mr-2 mb-2 border" style={{ objectFit: 'cover', borderRadius: 4 }} />
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-md addbtn">Add Gift Product</button>
        </div>
      </form>
    </div>
  );
};

export default AddGiftProduct;
